import { render, staticRenderFns } from "./ProductHistorySection.vue?vue&type=template&id=6248140e&scoped=true"
import script from "./ProductHistorySection.vue?vue&type=script&lang=js"
export * from "./ProductHistorySection.vue?vue&type=script&lang=js"
import style0 from "./ProductHistorySection.vue?vue&type=style&index=0&id=6248140e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6248140e",
  null
  
)

export default component.exports